(() => {
  const initializeStory = (root) => {
    if (!root || root.dataset.pvStoryReady === 'true') return;

    root.dataset.pvStoryReady = 'true';

    if (root.dataset.revealEnabled !== 'true') return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = Array.from(root.querySelectorAll('[data-pv-reveal]'));

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    root.classList.add('pv-story--js');

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      },
    );

    revealItems.forEach((item, index) => {
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
      observer.observe(item);
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-pv-story]').forEach(initializeStory);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
